"use client";

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import Cookies from 'js-cookie';
import { Button } from '@/components/ui/Button';

export function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if the user has already consented
    const consent = Cookies.get('lyricsverse_cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    Cookies.set('lyricsverse_cookie_consent', 'accepted', { expires: 365 });
    setIsVisible(false);
  };

  const handleDecline = () => {
    Cookies.set('lyricsverse_cookie_consent', 'declined', { expires: 365 });
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed bottom-0 inset-x-0 z-50 p-4 md:p-6 pointer-events-none transition-all duration-300 ease-out will-change-transform"
      style={{ transform: 'translateZ(0)' }}
    >
      <div className="max-w-7xl mx-auto pointer-events-auto">
        <div className="bg-card border border-border shadow-2xl rounded-2xl p-5 md:p-6 flex flex-col md:flex-row items-center justify-between gap-5">
          
          <div className="flex-grow space-y-1">
            <h3 className="text-base md:text-lg font-bold text-foreground">We value your privacy</h3>
            <p className="text-xs md:text-sm text-foreground font-medium leading-relaxed">
              We use cookies to enhance your browsing experience, serve personalized ads, and analyze our traffic. 
              By clicking "Accept All", you consent to our use of cookies. Read our{' '}
              <Link 
                href="/cookie-policy" 
                prefetch={false}
                className="text-primary font-bold underline underline-offset-2 hover:text-primary/80 transition-colors"
              >
                Cookie Policy
              </Link>{' '}
              for more information.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-2.5 w-full md:w-auto shrink-0">
            <Button variant="outline" onClick={handleDecline} className="w-full sm:w-auto font-semibold text-xs md:text-sm">
              Decline Optional
            </Button>
            <Button variant="primary" onClick={handleAccept} className="w-full sm:w-auto font-semibold text-xs md:text-sm">
              Accept All
            </Button>
          </div>

        </div>
      </div>
    </div>
  );
}
